<template>
    <div class="o-notFound u-py20 u-overflowYAuto">
        <div class="o-notFound__inner u-container">
            <h2 class="o-notFound__title">404 - Pagina niet gevonden</h2>
            <p>Pagina niet gevonden</p>
            <a href="/#/home" class="a-button">Ga naar home</a>
        </div>
    </div>
</template>

<script setup>

</script>